import containerFuild from '../html-snippets/container-fuild.js';

import css from '../css-snippets/section-sowhatbuy-guarantee-marquee.js';

const BG_IMAGE = 'https://cdn.skyfastimg.com/images/2026/07/01/image-6a448fc9a953916511f43c8e.webp?w=1000&h=50&q=80';

const ICON_LEFT = 'https://cdn.skyfastimg.com/images/2026/07/01/image-6a448fef19ac8d4a98d533df.webp?w=500&h=50&q=80';

const ICON_RIGHT = 'https://cdn.skyfastimg.com/images/2026/07/01/image-6a448ffb94cf301c374228ac.webp?w=500&h=50&q=80';

const MARQUEE_ICON = 'https://cdn.skyfastimg.com/images/2026/07/01/image-6a449007043fff310e823b70.png?w=500&h=50&q=80';

const defaultMarqueeItems = [
  { text: 'Risk-Free Purchase', icon: MARQUEE_ICON },
  { text: '30-Day Money-Back Guarantee', icon: MARQUEE_ICON },
  { text: 'Order Processed Within 24 Hours', icon: MARQUEE_ICON },
];

const marqueeItemHtml = ({ text, icon }) => `
  <div
    data-attribute="sowhatbuy-guarantee-marquee__marquee-item"
    class="sowhatbuy-guarantee-marquee__marquee-item"
  >
    <div class="sowhatbuy-guarantee-marquee__marquee-icon">
      <img
        data-attribute="sowhatbuy-guarantee-marquee__marquee-item-icon"
        src="${icon}"
        alt=""
      />
    </div>
    <div
      data-attribute="sowhatbuy-guarantee-marquee__marquee-item-text"
      class="sowhatbuy-guarantee-marquee__marquee-text"
    >
      ${text}
    </div>
  </div>
`;

const marqueeItemsHtml = defaultMarqueeItems.map(marqueeItemHtml).join('');

const contentHtml = `
 <div
  class="sowhatbuy-guarantee-marquee container"
  data-attribute="sowhatbuy-guarantee-marquee-content"
>
  <div
    class="sowhatbuy-guarantee-marquee__header"
    data-attribute="sowhatbuy-guarantee-marquee__header"
  >
    <div
      class="sowhatbuy-guarantee-marquee__header-icon sowhatbuy-guarantee-marquee__header-icon--left"
      data-attribute="sowhatbuy-guarantee-marquee__header-icon-left"
      data-show="true"
      data-icon-size-desktop="72"
      data-icon-size-mobile="48"
      style="--icon-size-desktop: 72px; --icon-size-mobile: 48px"
    >
      <img
        data-attribute="sowhatbuy-guarantee-marquee__header-icon-left-img"
        src="${ICON_LEFT}"
        alt=""
      />
    </div>

    <div
      class="sowhatbuy-guarantee-marquee__header-title"
      data-attribute="sowhatbuy-guarantee-marquee__header-title"
    >
      <h2 style="text-align:center;"><span style="font-size:32px;"><strong>Risk-Free </strong></span><span style="color:hsl(55,100%,50%);font-size:32px;"><strong>30-Day</strong></span><span style="font-size:32px;"><strong> Guarantee!</strong></span></h2>
    </div>
    <div
      class="sowhatbuy-guarantee-marquee__header-icon sowhatbuy-guarantee-marquee__header-icon--right"
      data-attribute="sowhatbuy-guarantee-marquee__header-icon-right"
      data-show="true"
      data-icon-size-desktop="72"
      data-icon-size-mobile="48"
      style="--icon-size-desktop: 72px; --icon-size-mobile: 48px"
    >
      <img
        data-attribute="sowhatbuy-guarantee-marquee__header-icon-right-img"
        src="${ICON_RIGHT}"
        alt=""
      />
    </div>
  </div>

  <div
    class="sowhatbuy-guarantee-marquee__marquee"
    data-attribute="sowhatbuy-guarantee-marquee__marquee"
  >
    <div
      class="sowhatbuy-guarantee-marquee__marquee-track"
      data-attribute="sowhatbuy-guarantee-marquee__marquee-track"
    >
      ${marqueeItemsHtml}
    </div>
  </div>
</div>
`;

export default containerFuild(contentHtml, css, {
  backgroundImage: BG_IMAGE,
  textColor: '#ffffff',
  topPadding: true,
  bottomPadding: true,
});
